import {
  CustomRolePermissionDto,
  CustomRolePermissionDtoWithoutAliasDto,
} from '../../../api-client';

export const filterCustomRolePermissions = (
  customRolePermissions: CustomRolePermissionDto[],
  newPermissions: CustomRolePermissionDto[],
): CustomRolePermissionDto[] => {
  const result: CustomRolePermissionDtoWithoutAliasDto[] = [...customRolePermissions].map((p) => ({
    id: p.id,
    attributes: p.attributes,
  }));
  newPermissions.forEach((p) => {
    if (!result.some((i) => i.id === p.id)) {
      result.push(p);
    }
  });

  return result;
};
